const Cart = () => import(/* webpackChunkName: "cart" */ '@/pages/member/cart/index') // 购物车
const Pecenter = () => import(/* webpackChunkName: "pecenter" */ '@/pages/member/pecenter/index') // 个人中心
const Recipient = () => import(/* webpackChunkName: "recipient" */ '@/pages/member/recipient') // 收件人地址
const Asset = () => import(/* webpackChunkName: "asset" */ '@/pages/member/asset') // 我的资产
const BillAddress = () =>
  import(/* webpackChunkName: "bill-address" */ '@/pages/member/billAddress') // 账单地址
const Withdraw = () => import(/* webpackChunkName: "withdraw" */ '@/pages/member/withdraw') // 提现余额
const AccountInfo = () =>
  import(/* webpackChunkName: "account-info" */ '@/pages/member/accountInfo/index.vue') // 账户信息
const SelfInfo = () =>
  import(/* webpackChunkName: "self-info" */ '@/pages/member/accountInfo/SelfInfo') // 个人信息
const AccountSafe = () =>
  import(/* webpackChunkName: "account-safe" */ '@/pages/member/accountInfo/AccountSafe') // 账户安全
const EditPassword = () =>
  import(/* webpackChunkName: "edit-password" */ '@/pages/member/accountInfo/EditPwd') // 设置密码
const Parcel = () => import(/* webpackChunkName: "may-package" */ '@/pages/member/myPackage') // 我的包裹
const MyStorage = () => import(/* webpackChunkName: "my-storage" */ '@/pages/member/storage') // 我的仓库

const PackageDetail = () =>
  import(/* webpackChunkName: "package-detail" */ '@/pages/member/packageDetail') // 包裹详情
const MemberLayout = () => import(/* webpackChunkName: "member-layout" */ '@/pages/member/Layout')
const MemberOrder = () => import(/* webpackChunkName: "member-order" */ '@/pages/member/order')
const OrderDetail = () =>
  import(/* webpackChunkName: "order-detail" */ '@/pages/member/orderDetail')

const BankTransfer = () =>
  import(/* webpackChunkName: "bank-transfer" */ '@/pages/member/bankTransfer') // 银汇转账
const MyAffiliate = () =>
  import(/* webpackChunkName: "my-affiliate" */ '@/pages/member/myAffiliate/index') // 我的下属
const Message = () => import(/* webpackChunkName: "message" */ '@/pages/member/site/msg/index') // 站内信
const Reply = () => import(/* webpackChunkName: "reply" */ '@/pages/member/site/reply/index') // 站内信回复
const Consult = () => import(/* webpackChunkName: "consult" */ '@/pages/member/consult/index') // 咨询
const Favourite = () => import(/* webpackChunkName: "consult" */ '@/pages/member/favourite/index') // 咨询
// const DistributionLayout = () =>
//   import(
//     /* webpackChunkName: "distribution" */ '@/pages/distribution/Layout/index.vue'
//   );
const Dashboard = () =>
  import(
    /* webpackChunkName: "distribution-dashboard" */ '@/pages/distribution/dashboard/index.vue'
  )
const Invite = () =>
  import(/* webpackChunkName: "distribution-invite" */ '@/pages/distribution/invite/index.vue')
const BalanceDetail = () =>
  import(
    /* webpackChunkName: "distribution-invite" */ '@/pages/distribution/balanceDetail/index.vue'
  )
const CommissionDetail = () =>
  import(
    /* webpackChunkName: "distribution-invite" */ '@/pages/distribution/commissionDetail/index.vue'
  )
const WithdrawRecord = () =>
  import(/* webpackChunkName: "withdraw-record" */ '@/pages/distribution/withdrawRecord/index.vue')
const WithdrawMethod = () =>
  import(/* webpackChunkName: "withdraw-method" */ '@/pages/distribution/withdrawMethod/index.vue')
const Points = () => import(/* webpackChunkName: "points" */ '@/pages/member/points/index.vue')
const Tag = () => import(/* webpackChunkName: "tag" */ '@/pages/member/tag/index.vue')
const ThemeMode = () =>
  import(/* webpackChunkName: "theme-mode" */ '@/pages/member/accountInfo/ThemeMode')
const VipLevel = () =>
  import(/* webpackChunkName: "vip-level" */ '@/pages/member/vip-level/index.vue') // 会员等级
const VipLevelDetail = () =>
  import(/* webpackChunkName: "vip-level-detail" */ '@/pages/member/vip-level/Detail.vue') // 会员等级详情
const EmailSend = () =>
  import(/* webpackChunkName: "email-send" */ '@/pages/member/accountInfo/EmailSend/index.vue') // 邮件通知
const QCAuth = () =>
  import(/* webpackChunkName: "qc-auth" */ '@/pages/member/accountInfo/QCAuth/index.vue') // QC认证
const CustomSetting = () =>
  import(/* webpackChunkName: "custom-setting" */ '@/pages/member/custom-setting/index.vue') // 自定义设置
export default [
  {
    path: '/member',
    component: MemberLayout,
    redirect: '/member/pecenter',
    children: [
      { path: '/member/pecenter', name: 'pecenter', component: Pecenter },
      {
        path: '/member/account-info',
        name: 'account-info',
        component: AccountInfo,
        redirect: '/member/account-info/self',
        children: [
          {
            path: '/member/account-info/self',
            name: 'self-info',
            component: SelfInfo,
          },
          {
            path: '/member/account-info/recipient',
            name: 'recipient',
            component: Recipient,
          },
          {
            path: '/member/account-info/safe',
            name: 'account-safe',
            component: AccountSafe,
          },
          {
            path: '/member/account-info/bill-address',
            name: 'bill-address',
            component: BillAddress,
          },
          {
            path: '/member/account-info/edit-pwd',
            name: 'edit-pwd',
            component: EditPassword,
          },
          {
            path: '/member/account-info/theme-mode',
            name: 'theme-mode',
            component: ThemeMode,
          },
        ],
      },
      { path: '/member/vip-level', name: 'vip-level', component: VipLevel },
      { path: '/member/vip-level/detail', name: 'vip-level-detail', component: VipLevelDetail },
      { path: '/member/wallet', name: 'asset', component: Asset },

      { path: '/member/site/message', name: 'message', component: Message },
      { path: '/member/points', name: 'points', component: Points },
      { path: '/member/cart', name: 'cart', component: Cart },
      {
        path: '/member/favourite',
        name: 'favourite',
        component: Favourite,
      },
      { path: '/member/order', name: 'order-list', component: MemberOrder },
      { path: '/member/storage', name: 'storage', component: MyStorage },
      {
        path: '/member/my-package',
        name: 'my-package',
        component: Parcel,
      },
      {
        path: '/member/my-rehearsal-package',
        name: 'my-rehearsal-package',
        component: () =>
          import(
            /* webpackChunkName: "rehearsalPackage" */ '@/pages/member/myPackage/rehearsalPackage/index.vue'
          ), // 我的包裹,
      },
      {
        path: '/member/consult',
        name: 'consult',
        component: Consult,
      },
      { path: '/member/site/reply', name: 'reply', component: Reply },
      {
        path: '/member/bankTransfer',
        name: 'bank-transfer',
        component: BankTransfer,
      },

      {
        path: '/member/order/order-detail',
        name: 'order-detail',
        component: OrderDetail,
      },

      {
        path: '/member/pecenter/withdraw',
        name: 'withdraw',
        component: Withdraw,
      },

      {
        path: '/member/my-package/package-detail',
        name: 'package-detail',
        component: PackageDetail,
      },
      {
        path: '/member/my-package/package-detail/package-detail',
        name: 'package-detail',
        component: PackageDetail,
      },
      {
        path: '/member/custom-setting',
        name: 'custom-setting',
        redirect: '/member/custom-setting/tag',
        component: CustomSetting,
        children: [
          {
            path: '/member/custom-setting/tag',
            name: 'tag',
            component: Tag,
          },
          {
            path: '/member/custom-setting/email-send',
            name: 'email-send',
            component: EmailSend,
          },
          {
            path: '/member/custom-setting/qc-auth',
            name: 'qc-auth',
            component: QCAuth,
          },
        ],
      },

      {
        path: '/member/myAffiliate',
        name: 'my-affiliate',
        component: MyAffiliate,
      },

      {
        path: '/distribution',
        name: 'distribution',
        redirect: '/distribution/dashboard',
        children: [
          {
            path: '/distribution/dashboard',
            name: 'distribution-dashboard',
            meta: { title: 'dashboard' },
            component: Dashboard,
          },
          {
            path: '/distribution/user-detail',
            name: 'user-detail',
            meta: { title: 'userDetail' },
            component: Invite,
          },
          {
            path: '/distribution/balance-detail',
            name: 'balance-detail',
            meta: { title: 'balanceDetail' },
            component: BalanceDetail,
          },
          {
            path: '/distribution/commission-detail',
            name: 'commission-detail',
            meta: { title: 'commissionDetail' },
            component: CommissionDetail,
          },
          {
            path: '/distribution/withdraw-record',
            name: 'withdraw-record',
            meta: { title: 'withdrawRecord' },
            component: WithdrawRecord,
          },
          {
            path: '/distribution/setting',
            name: 'distribution-setting',
            meta: { title: 'setting' },
            component: WithdrawMethod,
          },
        ],
      },
    ],
  },
]
